const mod = require('jsonapi-flattener')

module.exports = mod
